import * as React from 'react';
export default function SvgComponent() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4a8 8 0 100 16 8 8 0 000-16zm2.9 6.123a.75.75 0 00-1.3-.746l-2.294 3.997a.25.25 0 01-.443-.018l-.434-.925a.75.75 0 10-1.358.638l.434.924c.601 1.282 2.397 1.356 3.102.128l2.294-3.998z"
  }));
}